import { render, staticRenderFns } from "./FileListPage.vue?vue&type=template&id=b2363480&scoped=true&"
import script from "./FileListPage.vue?vue&type=script&lang=ts&"
export * from "./FileListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2363480",
  null
  
)

export default component.exports